import './services-top.sass';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

// Import images
import image01 from '../../assets/images/image01.png';
import image02 from '../../assets/images/image02.png';
import image03 from '../../assets/images/image03.png';
import image04 from '../../assets/images/image04.png';
import image05 from '../../assets/images/image05.png';
import image06 from '../../assets/images/image06.png';
import image07 from '../../assets/images/image07.png';
import image08 from '../../assets/images/image08.png';
import image09 from '../../assets/images/image09.png';
import image10 from '../../assets/images/image10.png';
function Services_top() {
  const { t } = useTranslation();

  const images_list1_top = [
    {
      src: image01,
      largeDesc: t('services_list1_top.image01.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list1_top.image01.0.smallDesc'),
    },
    {
      src: image02,
      largeDesc: t('services_list1_top.image02.0.largeDesc'),
      price: '$15.9',
      smallDesc: t('services_list1_top.image02.0.smallDesc'),
    },
    {
      src: image03,
      largeDesc: t('services_list1_top.image03.0.largeDesc'),
      price: '$10.9',
      smallDesc: t('services_list1_top.image03.0.smallDesc'),
    },
    {
      src: image04,
      largeDesc: t('services_list1_top.image04.0.largeDesc'),
      price: '$25.9',
      smallDesc: t('services_list1_top.image04.0.smallDesc'),
    },
    {
      src: image05,
      largeDesc: t('services_list1_top.image05.0.largeDesc'),
      price: '$12.9',
      smallDesc: t('services_list1_top.image05.0.smallDesc'),
    },
  ];

  const images_list2_top = [
    {
      src: image06,
      largeDesc: t('services_list2_top.image06.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list2_top.image06.0.smallDesc'),
    },
    {
      src: image07,
      largeDesc: t('services_list2_top.image07.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list2_top.image07.0.smallDesc'),
    },
    {
      src: image08,
      largeDesc: t('services_list2_top.image08.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list2_top.image08.0.smallDesc'),
    },
    {
      src: image09,
      largeDesc: t('services_list2_top.image09.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list2_top.image09.0.smallDesc'),
    },
    {
      src: image10,
      largeDesc: t('services_list2_top.image10.0.largeDesc'),
      price: '$19.9',
      smallDesc: t('services_list2_top.image10.0.smallDesc'),
    },
  ];

  return (
    <Container fluid>
      <Row>
        <Col>
          <h1 className="h1-services">
            <Trans i18nKey="services__top_title" />
          </h1>
        </Col>
      </Row>

      <Row className="row-men">
        <h2 className="h2-services">
          <Trans i18nKey="servicestoptitle1" />
        </h2>
        <Swiper
          grabCursor={true}
          slidesPerView={3}
          spaceBetween={30}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          pagination={{ clickable: true, dynamicBullets: true }}
          modules={[Autoplay, Pagination]}
          className="swiper-slide"
          breakpoints={{
            0: { slidesPerView: 1 }, //  Show 1 slide on small screens (mobile)
            768: { slidesPerView: 2 }, //  Show 2 slides on tablets
            1024: { slidesPerView: 3 }, //  Show 3 slides on desktops
          }}
        >
          {images_list1_top.map((item, index) => (
            <SwiperSlide key={index}>
              <Image src={item.src} fluid className="image" />
              <div className="div-small-price">
                <span className="span-small">{item.smallDesc}</span>
                <span className="span-price">{item.price}</span>
              </div>
              <div className="div-large">
                <span className="span-large">{item.largeDesc}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Row>

      <Row className="row-women">
        <h2 className="h2-services">
          <Trans i18nKey="servicestoptitle2" />
        </h2>
        <Swiper
          grabCursor={true}
          slidesPerView={3}
          spaceBetween={30}
          autoplay={{ delay: 2500, disableOnInteraction: false }}
          pagination={{ clickable: true, dynamicBullets: true }}
          modules={[Autoplay, Pagination]}
          className="swiper-slide"
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {images_list2_top.map((item, index) => (
            <SwiperSlide key={index}>
              <Image src={item.src} fluid />
              <div className="div-small-price">
                <span className="span-small">{item.smallDesc}</span>
                <span className="span-price">{item.price}</span>
              </div>
              <div className="div-large">
                <span className="span-large">{item.largeDesc}</span>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </Row>
    </Container>
  );
}

export { Services_top };
